export default __webpack_public_path__ + "d8f4d2c773c33c3c07e37a967218ffa5.svg";